export const COMPANY = {
  name: "Ambrotech Private Limited",
  shortName: "Ambrotech",
  tagline: "Powering Industry, Building Trust.",
  website: "https://ambrotech.in",
  email: "official.ambrotech@gmail.com",
  intro:
    "Ambrotech Private Limited supplies solar energy products, electrical components, and related equipment for residential, commercial, and industrial requirements.",
};

export const SALES_PHONE = {
  label: "+91 92292 04554",
  tel: "tel:+919229204554",
};

export const TECH_PHONE = {
  label: "+91 80764 57992",
  tel: "tel:+918076457992",
  whatsapp: "https://wa.me/918076457992",
};

export const WHATSAPP_LINK =
  "https://wa.me/918076457992?text=" +
  encodeURIComponent(
    "Hello Ambrotech, I would like to enquire about your products and services."
  );

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Products", path: "/products" },
  { name: "Services", path: "/services" },
  { name: "Our Presence", path: "/presence" },
  { name: "Contact Us", path: "/contact" },
];

const u = (id, w) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=70`;

export const IMAGES = {
  hero: u("1694327671725-e2a81cda3436", 1600),
  solarField: u("1756511332583-99fc0d4bf7cf", 1200),
  engineer: u("1581092570490-cc40829efaae", 1000),
  panelsBlue: u("1589275776107-e193042128bd", 1000),
  helmetPanel: u("1648135327756-b606e2eb8caa", 1000),
  roofWorkers: u("1635424709870-cdc6e64f0e20", 1000),
  powerLines: u("1610028290816-5d937a395a49", 1000),
};

export const PRODUCTS = [
  {
    id: "solar-pv-modules",
    name: "Solar Panels / PV Modules",
    description:
      "Solar PV modules for residential, commercial, and industrial installations, supplied as per project requirements.",
    image: u("1558449028-b53a39d100fc", 900),
    alt: "Solar PV module under a clear blue sky",
  },
  {
    id: "solar-inverters",
    name: "Solar Inverters (On-Grid & Hybrid)",
    description:
      "On-grid and hybrid solar inverters for dependable power conversion across residential and commercial system sizes.",
    image: u("1713544123641-5328f51964e4", 900),
    alt: "Solar inverters mounted below a ground-mounted solar array",
  },
  {
    id: "phase-inverters",
    name: "Single-Phase & Three-Phase Inverters",
    description:
      "Single-phase and three-phase inverters suitable for homes, shops, and industrial loads.",
    image: u("1544724569-5f546fd6f2b5", 900),
    alt: "Electrical panel with circuit breakers and wiring",
  },
  {
    id: "lithium-batteries",
    name: "Lithium Batteries & Energy Storage",
    description:
      "Lithium batteries and energy storage systems for backup power and hybrid solar installations.",
    image: u("1780445392417-68b9dccc45f2", 900),
    alt: "Wall-mounted solar power and energy storage unit",
  },
  {
    id: "mounting-structures",
    name: "Solar Mounting Structures",
    description:
      "Galvanized steel and aluminium mounting structures for rooftop and ground-mounted solar systems.",
    image: u("1559302504-64aae6ca6b6d", 900),
    alt: "Workers carrying a metal mounting structure on site",
  },
  {
    id: "dc-wires-cables",
    name: "DC Wires & Cables",
    description:
      "Solar DC wires and cables in various sizes, rated for outdoor use and panel-to-inverter runs.",
    image: u("1687038520579-8d8f24721267", 900),
    alt: "Coils of black electrical DC cable",
  },
  {
    id: "ac-wires-cables",
    name: "AC Wires & Cables",
    description:
      "AC wires and cables for inverter-to-grid and distribution connections in solar and electrical systems.",
    image: u("1584774354932-62ceb99e6053", 900),
    alt: "Coil of copper electrical wire",
  },
  {
    id: "solar-connectors",
    name: "Solar Connectors (MC4 & More)",
    description:
      "MC4 and other solar connectors for secure panel and string interconnections.",
    image: u("1652715564391-38cc4475b7f5", 900),
    alt: "Close-up of wired electrical connectors",
  },
  {
    id: "bos-components",
    name: "BOS Components & Solar Accessories",
    description:
      "Balance-of-system components and solar accessories, including junction boxes, protection devices, and fasteners.",
    image: u("1558054665-fbe00cd7d920", 900),
    alt: "Rows of electrical switchgear and protection equipment",
  },
  {
    id: "cable-lugs-terminals",
    name: "Cable Lugs & Terminals",
    description:
      "Copper and aluminium cable lugs and terminals for secure electrical connections.",
    image: u("1717667745852-a5bd6876c1de", 900),
    alt: "Assorted wires and terminal connections",
  },
  {
    id: "other-products",
    name: "Other Solar, Electrical & Industrial Products",
    description:
      "A range of other solar, electrical, and industrial products supplied as per requirement and availability.",
    image: u("1610028290816-5d937a395a49", 900),
    alt: "Electrical power infrastructure",
  },
];

export const SERVICES = [
  {
    id: "solar-product-supply",
    title: "Solar Product Supply",
    description:
      "Solar modules, inverters, batteries, cables, mounting structures, and balance-of-system components can be supplied according to project requirements and availability.",
    image: IMAGES.panelsBlue,
    alt: "Blue solar PV modules installed in a row",
  },
  {
    id: "site-survey-planning",
    title: "Site Survey & System Planning",
    description:
      "Site assessment and system planning support to help determine the right system configuration, sizing, and components for your project.",
    image: IMAGES.helmetPanel,
    alt: "Safety helmet resting on a solar panel during a site survey",
  },
  {
    id: "installation-project-support",
    title: "Solar Installation & Project Support",
    description:
      "Installation support can be arranged according to the agreed scope, along with coordination and technical assistance during project execution.",
    image: IMAGES.roofWorkers,
    alt: "Technicians installing solar panels on a rooftop",
  },
];

export const OFFICES = [
  {
    city: "Delhi",
    label: "Corporate Office — Delhi",
    address:
      "KH No. 59, 2nd Floor, Street No. 2, Near Delhi Engineering College, North West Delhi, Delhi – 110042.",
    tag: "Corporate Office",
  },
  {
    city: "Patna",
    label: "Office — Patna",
    address:
      "304, 3rd Floor, Opposite Bandhan Bank, Near Loyola High School, Patna, Bihar – 800001.",
    tag: "Office",
  },
  {
    city: "Silvassa",
    label: "Industrial Presence — Silvassa",
    address:
      "Horizon Industrial Park, Masat Industrial Area, Masat, Silvassa – 396230.",
    tag: "Industrial Presence",
  },
];

export const mapsUrl = (address) =>
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent(address);